<template>
  <div class="dflexc-jcs marketplace-results-wrapper">
    <div class="dflexr-jcs" id="marketplace-results-panel"
         v-if="pkg.cityName !== ''">
      <results-header :pkg="pkg" />
    </div>
    <div class="dflexc-jcs market-view" v-if="ready">
      <market-place-selector />
      <market-place-card :mp_idx="pkg.active_mp" />
    </div>
    <div v-if="show_marketplace_help">
      <div class="lbl-numpad-txt" id="select-city-help">
        <p>Select a City, Village , or Town (CVT) from the list on the left,
        then click on the roll button below.</p>
        <p>If the CVT is not in the list,
        enter the name of the CVT. in the input field
        below.</p>
        <p>If population was not auto filled in,
          enter the population using the numeric pad and click on the roll button and
          it will be added to the database and the list.</p>
      </div>

    </div>

  </div>
</template>

<style scoped lang="scss">
//@import '../../assets/styles/colors';
//@import '../../assets/styles/marketplace-roller-view/;
@import '@/assets/styles/marketplace/sm.scss';
@import '@/assets/styles/marketplace/md.scss';
@import '@/assets/styles/marketplace/lg.scss';
@import '@/assets/styles/marketplace/xl';

.market-view {
  flex: 1;
}
</style>

<script setup>

import Item from './marketplace_results_item.vue'
import {onMounted, onUpdated, ref} from "vue"
import ResultsHeader from "@/components/marketplace/ResultsHeader.vue"
import MarketPlaceSelector from "@/components/marketplace/MarketPlaceSelector.vue"
import MarketPlaceCard from "@/components/marketplace/MarketPlaceCard.vue"

let mpStore = null
const props = defineProps(['pkg', 'show_marketplace_help'])
const ready = ref(false)

onMounted(() => {
  mpStore = window.novasectorapp.marketStore
  getCurrentSet()
  if(props.pkg.cityName !== '')
    ready.value = true
})

onUpdated(() => {
  if(props.pkg.cityName !== '')
    ready.value = true
  // getCurrentSet()
})

function getCurrentSet() {
  // if props.jpkg is empty, log this, and do nothing else
  if(Object.keys(props.pkg).length === 0) {
    console.log('props.pkg was empty')
    return
  }
  // adjust max widths if not empty
  if(props.pkg.qty > 0)
    mpStore.determineMaxWidth()

  // move props.jpkg data to local non-props object jewel_data
  // not sure this is useful, but...
  Object.assign(props.pkg, mpStore.currentSet)


}

</script>
